import React from 'react';
import './index.css';

export default class Credits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.props.hideCredits()
  }

  render() {
    return (
        <div id='credits'>
          <h3 onClick={()=>this.handleClick()}>Close</h3>
          <div className="creditsBig">Created By <a href="https://www.squadtiming.com/about/" >Paul Schorey</a></div>
          <div className="creditsBig">Background Artwork <a href="https://www.raventalestudio.com" >RavenTale</a></div>
          <div className="creditsBig">Dino Artwork <a href="https://pzuh.itch.io" >pzUH</a></div>                   
          <div className="creditsBig">SFX Made With <a href="https://www.leshylabs.com/apps/sfMaker/" >Leshylabs</a></div>
          {/*<div class="creditsBig">Typing Sound From <a href="https://www.freesound.org">FreeSound</a></div>*/}
          <div className="creditsBig">Icons Made With <a href="https://vectr.com" >Vectr</a></div>
          <div className="creditsBig">Wordlist Modified From <a href="https://github.com/first20hours/google-10000-english" >Josh Kaufman</a></div>
          <div className="creditsSmall">Copyright Paul Schorey 2021 All Rights Reserved</div>
        </div>
    )
  }
}



